<template>
  <div>
    <b-modal
      v-model="isToggle"
      id="selectStaff"
      body-class="p-0"
      hide-footer
      hide-header
      :no-close-on-backdrop="canClose"
    >
      <div class="modal-staff">
        <div class="header">
          <b-input-group class="panel-input-serach">
            <b-form-input
              v-model="search"
              class="input-serach"
              placeholder="ค้นหารหัส, ชื่อ"
              @keyup.enter="getListStaff"
            ></b-form-input>
            <b-input-group-prepend>
              <span class="icon-input m-auto pr-2" @click="getListStaff">
                <font-awesome-icon icon="search" title="View" />
              </span>
            </b-input-group-prepend>
          </b-input-group>
        </div>
        <div class="body">
          <b-row no-gutters v-if="data.length > 0">
            <b-col
              cols="6"
              class="p-2"
              v-for="(item, index) in data"
              :key="index"
            >
              <b-form-radio
                name="radio-size"
                v-model="selected"
                :value="item.id"
                :disabled="item.isActive == 1 && true"
              >
                <div class="text" :class="item.isActive == 1 && 'white'">
                  <p class="m-0">รหัส {{ item.staffNo }}</p>
                  <p class="m-0 fullname">
                    {{ item.firstName }} {{ item.lastName }}
                  </p>
                </div>
              </b-form-radio>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col cols="12" class="text-center">
              <p class="m-0">ไม่มีข้อมูล</p>
            </b-col>
          </b-row>
        </div>
        <div class="footer">
          <b-button
            class="btn-select"
            @click="conditionStaff"
            :disabled="selected == '' ? true : false"
          >
            เลือก
            <b-spinner
              class="icon-spinner"
              label="Spinning"
              v-if="isSpinner"
            ></b-spinner>
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // state data
      selected: "",
      data: [],
      search: "",

      // state toggle
      isToggle: false,
      isSpinner: false,
    };
  },
  computed: {
    canClose() {
      let result = true;

      let getToken = this.$cookies.get("tnl-session-token");

      if (getToken) {
        result = false;
      }

      return result;
    },
  },
  watch: {
    isToggle(val) {
      if (val) {
        this.getListStaff();
      }
    },
  },

  methods: {
    conditionStaff() {
      let getToken = this.$cookies.get("tnl-session-token");

      this.isSpinner = true;

      if (getToken) {
        this.logoutOldStaff();
      } else {
        this.selectStaff();
      }
    },
    selectStaff() {
      this.axios
        .post(
          `${this.$baseUrl}/staff/select/${this.selected}/${this.$cookies.get(
            "user-id"
          )}`
        )
        .then((data) => {
          if (data.result == 1) {
            this.$emit("success", data.detail.token);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    logoutOldStaff() {
      this.axios
        .post(`${this.$baseUrl}/account/logout`)
        .then((data) => {
          if (data.result == 1) {
            this.selectStaff();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getListStaff() {
      let url = "";

      if (this.search) {
        url = `${this.$baseUrl}/staff/list/${this.$cookies.get(
          "user-id"
        )}?search=${this.search}`;
      } else {
        url = `${this.$baseUrl}/staff/list/${this.$cookies.get("user-id")}`;
      }

      this.axios
        .get(url)
        .then((data) => {
          if (data.result == 1) {
            this.data = data.detail.result;
            this.selected = "";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-staff {
  .header {
    border-radius: 8px 8px 0px 0px;
    padding: 10px;
  }

  .body {
    max-height: calc(100vh - 170px);

    overflow-x: hidden;
    padding: 10px;

    .text {
      &.white {
        color: #cccccc;
      }
    }

    .fullname {
      width: 190px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .footer {
    border-radius: 0px 0px 8px 8px;
    padding: 10px;

    .btn-select {
      background: #b41bb4 !important;
      color: white;
      min-width: 100px;

      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;

      .icon-spinner {
        width: 15px;
        height: 15px;
        margin-left: 10px;
      }
    }
  }
}
</style>
